// extracted by mini-css-extract-plugin
module.exports = {"guideWrapper":"EmailHideCoupon_guideWrapper__1Nwlm","guideHide":"EmailHideCoupon_guideHide__1MHBk","guideBtn":"EmailHideCoupon_guideBtn__3FPHA"};